module.exports = __webpack_public_path__ + "static/media/star-orange.2a7ae38e.svg";